<template lang="pug">
router-link(
  to="/"
)
  SvIcon(
    icon="logo"
    :width="width"
    :height="height"
  )
</template>

<script>
import SvIcon from '@/components/uikit/SvIcon.vue';

export default {
  name: 'Logo',

  props: {
    width: {
      type: Number,
      default: 145,
    },

    height: {
      type: Number,
      default: 64,
    },
  },

  components: {
    SvIcon,
  },
};
</script>
